import { BarChart3, BriefcaseBusiness, CalendarClock, Database, FileSignature, LayoutDashboard, Scale, SquareCheckBig, Users } from 'lucide-react';

export const dashboardIconOptions = [
    { key: 'layout', label: 'Dashboard', Icon: LayoutDashboard },
    { key: 'tasks', label: 'Tasks', Icon: SquareCheckBig },
    { key: 'cases', label: 'Cases', Icon: BriefcaseBusiness },
    { key: 'chart', label: 'Chart', Icon: BarChart3 },
    { key: 'database', label: 'Data', Icon: Database },
    { key: 'signature', label: 'Signatures', Icon: FileSignature },
    { key: 'calendar', label: 'Calendar', Icon: CalendarClock },
    { key: 'team', label: 'Team', Icon: Users },
    { key: 'legal', label: 'Legal', Icon: Scale },
];

export const getDashboardIcon = (iconKey) => {
    return dashboardIconOptions.find(option => option.key === iconKey)?.Icon || LayoutDashboard;
};
